import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../layouts/default";
import { Row, Col, Button, Form, Modal, Table } from "react-bootstrap";
import ProgressBar from "../../../components/Campaigns/ProgressBar";
import { useSelector, useDispatch } from "react-redux";
import Classes from "../style.module.css";
import Select from "react-select";
import { getVendorAccounts } from "../../../store/slices/vendors/vendors";
import { useNavigate, useParams } from "react-router-dom";
import {
    addHodublastJobs,
    fetchHodublastJobs,
    deleteHodublastJob,
    fetchAllHodublastJobs
} from "../../../store/slices/hodublast";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import CampaignFooter from "../../../components/Campaigns/CampaignFooter";
import { loadCampaign, updateCampaign } from "../../../store/slices/campaigns/createCampaign";

function SetVendorConfiguration() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    const { campaignRecurrence } = useSelector(
        (state) => state.createCampaignRecurrenceSlice
    );
    const { campaign, updateCampData } = useSelector(
        (state) => state.createCampaignSlice
    );
    const { vendorAccounts, loading, error } = useSelector(
        (store) => store.vendorReducer
    );
    const { hodublastJobs, allHodublastJobs } = useSelector((state) => state.hodublastReducer);
    const isRepeatCampaign = campaign?.data?.isRepeat;
    const isIvrMarketingCampaign = campaign?.data?.channel.name === 'ivr_marketing';
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [showAddJobModal, setShowAddJobModal] = useState(false);
    const [jobs, setJobs] = useState([]);
    const [selectedJobs, setSelectedJobs] = useState([]);

    useEffect(() => {
        if (id) dispatch(loadCampaign(id));
    }, [id, dispatch]);


    useEffect(() => {
        if (campaign?.data?.id) {
            dispatch(fetchHodublastJobs({ campaign_id: campaign.data.id }));

            if (campaign?.data?.vendor?.name === "Hodublast") {
                dispatch(getVendorAccounts({ vendorId: campaign.data.vendor.id }));
            }
        }
    }, [
        campaign?.data?.id,
        campaign?.data?.vendor?.id,
        campaign?.data?.vendor?.name,
        dispatch,
    ]);


    useEffect(() => {
        setJobs(Array.isArray(hodublastJobs?.data) ? hodublastJobs.data : []);
    }, [hodublastJobs?.data]);


    const vendorOptions = useMemo(() => {
        if (Array.isArray(vendorAccounts)) {
            return vendorAccounts.map((account) => ({
                value: account.id,
                label: account.name,
            }));
        }
        return [];
    }, [vendorAccounts]);

    const handleAccountChange = (selected) => setSelectedAccount(selected);

    // Submit selected jobs (excluding already added ones)
    const handleSubmitSelectedJobs = async () => {
        if (!selectedAccount) {
            toast.error("Please select an account first.");
            return;
        }

        const newJobsToAdd = allHodublastJobs.data.filter(
            (job) =>
                selectedJobs.includes(job.job_id) &&
                !jobs.some((addedJob) => addedJob.job_id === job.job_id)
        );

        if (newJobsToAdd.length === 0) {
            toast.info("No new jobs selected to add.");
            setShowAddJobModal(false);
            return;
        }

        const formattedJobs = newJobsToAdd.map((job) => ({
            job_id: job.job_id,
            job_name: job.job_name,
            job_max_try: job.job_max_try,
            account_id: selectedAccount.value,
            campaign_id: campaign?.data?.id,
        }));

        await dispatch(addHodublastJobs(formattedJobs));
        await dispatch(fetchHodublastJobs({ campaign_id: campaign?.data?.id }));

        toast.success(`${formattedJobs.length} job(s) added successfully!`);
        setSelectedJobs([]);
        setShowAddJobModal(false);
    };

    const handleDeleteJob = async (id) => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this Job?"
        );
        if (!confirmDelete) return;

        const resultAction = await dispatch(deleteHodublastJob({ id }));

        if (resultAction?.payload?.success) {
            await dispatch(fetchHodublastJobs({ campaign_id: campaign?.data?.id }));
        } else {
            toast.error("Failed to delete job. Please try again.");
        }
    };

    const handleSaveAndContinue = (path, isFinal) => {
        if (jobs.length === 0) {
            toast.error("Please add at least one job before continuing.");
            return;
        }

        if (isRepeatCampaign || !isFinal) {
            navigate(path);
        } else {
            const payload = { id, status: "published" };
            dispatch(updateCampaign(payload))
            toast.success("Campaign Successfully Created.");
            if (isFinal) {
                navigate('/campaigns')
            }
        }

    };

    const handleSelectHodublastJobs = () => {

        // calling api to get the jobs from hodublast
        console.log("dkjfkdasfskdj : ", selectedAccount);

        if (!selectedAccount) {
            toast.error("Please select a account.");
            return;
        }

        const payload = {
            accountName: selectedAccount.label,
            accountId: selectedAccount.value,
        }

        dispatch(fetchAllHodublastJobs(payload));

        setShowAddJobModal(true);
    }

    const handleAddHodublastJobs = () => {
        navigate('/job-list');
    }

    // Handle checkbox selection
    const handleJobSelection = (e, job) => {
        if (e.target.checked) {
            setSelectedJobs((prev) => [...prev, job.job_id]);
        } else {
            setSelectedJobs((prev) => prev.filter((id) => id !== job.job_id));
        }
    };

    // Show loader AFTER hooks
    if (!campaign?.data?.id) {
        return <div className="text-center mt-5">Loading campaign...</div>;
    }

    return (
        <Layout>
            <Row>
                <Col md={8}>
                    <div className="pageHeader mb-4">
                        <h3 className="smallHeading mb-3">IVR Vendor Configuration</h3>
                        <h1>Set Vendor Configuration</h1>
                    </div>

                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label>Select HoduBlast Account</Form.Label>
                            <Select
                                options={vendorOptions}
                                value={selectedAccount}
                                onChange={handleAccountChange}
                                placeholder={
                                    loading ? "Loading accounts..." : "Select a HoduBlast Account"
                                }
                                isDisabled={loading || !!error}
                            />
                            {error && <div className="errorText mt-2">Error: {error}</div>}
                            {!loading && vendorOptions.length === 0 && (
                                <div className="text-muted mt-2">No accounts found.</div>
                            )}
                        </Form.Group>

                        <div className="d-flex justify-content-between align-items-center">
                            <Button
                                variant="primary"
                                onClick={() => handleSelectHodublastJobs()}
                                disabled={!selectedAccount}
                            >
                                Select Jobs
                            </Button>

                            <Button variant="primary" onClick={() => handleAddHodublastJobs()}>
                                Add Jobs
                            </Button>
                        </div>
                    </Form>

                    {jobs.length > 0 && (
                        <div className="mt-4">
                            <h5>All Jobs:</h5>
                            <Table striped bordered size="sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Job ID</th>
                                        <th>Job Name</th>
                                        <th>Job Max Try</th>
                                        <th>Account Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobs.map((job, index) => (
                                        <tr key={job.id || job.job_id}>
                                            <td>{index + 1}</td>
                                            <td>{job.job_id}</td>
                                            <td>{job.job_name}</td>
                                            <td>{job.job_max_try}</td>
                                            <td>{job?.account?.name || "NA"}</td>
                                            <td className="text-center">
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => handleDeleteJob(job.id)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    <div className="mt-4 text-end">
                        {
                            isIvrMarketingCampaign ? <CampaignFooter
                                nextStep="Set Setting"
                                buttonTitle={"Save Configuration"}
                                onNextStepHandler={() => handleSaveAndContinue(`/campaigns/edit/setting/${campaign?.data?.id}`, false)}
                                showDraft={false}
                            /> : <CampaignFooter
                                nextStep="Schedule and Publish"
                                buttonTitle={isRepeatCampaign ? "Save Configuration" : "Save and Publish"}
                                onNextStepHandler={() => handleSaveAndContinue(`/campaigns/edit/schedule/${campaign?.data?.id}`, true)}
                                showDraft={!campaign?.data?.isRepeat}
                            />
                        }
                    </div>

                    {/* Add Job Modal */}
                    <Modal
                        show={showAddJobModal}
                        onHide={() => setShowAddJobModal(false)}
                        size="lg"
                        centered
                        className="job-modal"
                    >
                        <Modal.Header closeButton className="bg-light border-0 py-3">
                            <Modal.Title className="fw-semibold">
                                <i className="bi bi-briefcase-fill text-primary me-2"></i>
                                Select Jobs to Add
                                {Array.isArray(allHodublastJobs?.data) && (
                                    <span className="badge bg-secondary ms-2">
                                        {allHodublastJobs.data.length} total
                                    </span>
                                )}
                                {selectedJobs.length > 0 && (
                                    <span className="badge bg-success ms-2">
                                        {selectedJobs.length} selected
                                    </span>
                                )}
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="p-0">
                            {allHodublastJobs?.loading ? (
                                <div
                                    className="d-flex flex-column justify-content-center align-items-center py-5"
                                    style={{
                                        background: "linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)",
                                    }}
                                >
                                    <div
                                        className="spinner-border text-primary mb-3"
                                        role="status"
                                        style={{ width: "3rem", height: "3rem" }}
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <h6 className="text-primary fw-semibold">
                                        Fetching jobs from HoduBlast...
                                    </h6>
                                </div>
                            ) : Array.isArray(allHodublastJobs?.data) &&
                                allHodublastJobs.data.length > 0 ? (
                                <div className="table-responsive" style={{ maxHeight: "55vh", overflowY: "auto" }}>
                                    <Table hover className="align-middle mb-0">
                                        <thead className="table-light sticky-top shadow-sm">
                                            <tr>
                                                <th style={{ width: "80px" }} className="text-center">Select</th>
                                                <th>Job ID</th>
                                                <th>Job Name</th>
                                                <th>Job Max Try</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allHodublastJobs.data.map((job, idx) => {
                                                const isAlreadyAdded = jobs.some(
                                                    (addedJob) => addedJob.job_id === job.job_id
                                                );
                                                const isSelected = selectedJobs.includes(job.job_id);
                                                return (
                                                    <tr
                                                        key={idx}
                                                        className={
                                                            isAlreadyAdded
                                                                ? "bg-light text-muted"
                                                                : isSelected
                                                                    ? "table-primary"
                                                                    : ""
                                                        }
                                                    >
                                                        <td className="text-center">
                                                            <Form.Check
                                                                type="checkbox"
                                                                value={job.job_id}
                                                                checked={isAlreadyAdded || isSelected}
                                                                disabled={isAlreadyAdded}
                                                                onChange={(e) => handleJobSelection(e, job)}
                                                            />
                                                        </td>
                                                        <td className="fw-semibold">{job.job_id}</td>
                                                        <td>{job.job_name}</td>
                                                        <td>{job.job_max_try}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            ) : (
                                <div className="text-center py-5 text-muted bg-light">
                                    <i className="bi bi-info-circle fs-3 mb-2 d-block"></i>
                                    <p>No jobs found for this account.</p>
                                </div>
                            )}
                        </Modal.Body>

                        <Modal.Footer className="bg-light border-0 d-flex justify-content-between align-items-center py-3">
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowAddJobModal(false)}
                            >
                                <i className="bi bi-x-circle me-1"></i> Cancel
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleSubmitSelectedJobs}
                                disabled={selectedJobs.length === 0}
                                className="shadow-sm"
                            >
                                <i className="bi bi-plus-circle me-1"></i>
                                Add Selected Jobs
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </Col>

                <Col md={4} className={Classes.sidebarBackground}>
                    <div className={Classes.sidebarBackground} style={{ height: "100vh" }}>
                        <ProgressBar
                            campaign={campaign}
                            updateCampData={updateCampData}
                            campaignRecurrence={campaignRecurrence}
                        />
                    </div>
                </Col>
            </Row>
        </Layout>
    );
}

export default SetVendorConfiguration;
